<template>
  <v-col>
    <v-row dense align="center" justify="center">
      <v-col cols="auto" class="ma-1 caption">low</v-col>
      <v-col>
        <v-sheet height="20" :style="{ background: background }"></v-sheet>
      </v-col>
      <v-col cols="auto" class="ma-1 caption">high</v-col>
    </v-row>
    <v-spacer class="pa-3" />
    <v-row dense align="center" justify="center" class="text-caption">
      <v-tooltip location="bottom center" origin="auto">
        <template #activator="{ props }">
          <span v-bind="props">
            <v-icon class="ml-1 mb-1" icon="mdi-chevron-up" />
            <v-icon class="ml-1 mb-1" icon="mdi-chevron-down" />
          </span>
        </template>
        More than 5% change
      </v-tooltip>

      <v-tooltip location="bottom center" origin="auto">
        <template #activator="{ props }">
          <span v-bind="props">
            <v-icon class="ml-1 mb-1" icon="mdi-chevron-double-up" />
            <v-icon class="ml-1 mb-1" icon="mdi-chevron-double-down" />
          </span>
        </template>
        More than 10% change
      </v-tooltip>

      <v-tooltip location="bottom center" origin="auto">
        <template #activator="{ props }">
          <span v-bind="props">
            <v-icon class="ml-1 mb-1" icon="mdi-chevron-triple-up" />
            <v-icon class="ml-1 mb-1" icon="mdi-chevron-triple-down" />
          </span>
        </template>
        More than 15% change
      </v-tooltip>
    </v-row>
    <v-spacer class="pa-1" />
    <v-row class="text-center text-caption ma-1">
      <v-col>All prices are $/MWh</v-col>
    </v-row>
  </v-col>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HeatMap from '@/heatMaps/heatMap';
import router from '@/router';

export default defineComponent({
  name: 'LegendComponent',
  computed: {
    background: () => {
      const colorRatios = HeatMap.default.colorStops.map(({ color, ratio }) => `${color.toRgba(0.75)} ${ratio * 100}%`);
      return `linear-gradient(90deg, ${colorRatios.join(', ')}) !important`;
    }
  },
  methods: {
    setMode(mode: string) {
      console.log('set mode', mode);
      router.push({ query: { ...this.$route.query, mode: mode } });
    }
  }
});
</script>
